import { useMemo } from 'react'

import { Box, Grid, Skeleton } from '@mui/material'
import { useFormContext } from 'react-hook-form'

import { ControlledCheckbox, ControlledSelector, ControlledTextField } from 'components/common'
import {
  CreateAndUpdateTariffCategoryDtoInput,
  SortEnumType,
  useGetVehicleTypesQuery,
} from 'generated/graphql'

const TariffCategoryForm = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<CreateAndUpdateTariffCategoryDtoInput>()

  const { loading: vehicleTypeLoading, data: vehicleTypeData } = useGetVehicleTypesQuery({
    variables: {
      order: {
        sequenceOrder: SortEnumType.Asc,
      },
    },
  })

  const vehicleTypesValues = useMemo(() => {
    if (!vehicleTypeLoading && !!vehicleTypeData) {
      return vehicleTypeData.vehicleTypes.map((vt) => ({
        value: Number(vt.id),
        label: vt.name,
      }))
    }
    return []
  }, [vehicleTypeData, vehicleTypeLoading])

  return (
    <Box pt={1}>
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <ControlledTextField
            control={control}
            name='name'
            label='Name'
            required
            error={!!errors.name}
            helperText={errors.name?.message}
          />
        </Grid>

        <Grid item xs={6}>
          {vehicleTypeLoading ? (
            <Skeleton height='100%' animation='wave' />
          ) : (
            <ControlledSelector
              control={control}
              name='vehicleTypeId'
              label='Vehicle Type'
              options={vehicleTypesValues}
              emptyValue={{ value: '', label: 'None' }}
              defaultValue=''
              error={!!errors.vehicleTypeId}
              helperText={errors.vehicleTypeId?.message}
            />
          )}
        </Grid>
        <Grid item xs={6}>
          <ControlledCheckbox control={control} name='hasSpotRate' label='Has Spot-Rate' />
        </Grid>
      </Grid>
    </Box>
  )
}

export default TariffCategoryForm
